import { useEffect, useRef } from "react";

// A box to draw a signature in with a finger or mouse. onChange(PNG data URL | null).
export function DrawPad({ onChange }) {
  const ref = useRef(null);
  const drawing = useRef(false);
  const used = useRef(false);
  useEffect(() => {
    const c = ref.current, ctx = c.getContext("2d");
    ctx.lineWidth = 2.2; ctx.lineCap = "round"; ctx.strokeStyle = "#0F3A52";
    const pos = e => { const r = c.getBoundingClientRect(); return [(e.clientX - r.left) * (c.width / r.width), (e.clientY - r.top) * (c.height / r.height)]; };
    const down = e => { drawing.current = true; ctx.beginPath(); ctx.moveTo(...pos(e)); c.setPointerCapture(e.pointerId); };
    const move = e => { if (!drawing.current) return; ctx.lineTo(...pos(e)); ctx.stroke(); used.current = true; };
    const up = () => { if (!drawing.current) return; drawing.current = false; if (used.current) onChange(c.toDataURL("image/png")); };
    c.addEventListener("pointerdown", down); c.addEventListener("pointermove", move); c.addEventListener("pointerup", up);
    return () => { c.removeEventListener("pointerdown", down); c.removeEventListener("pointermove", move); c.removeEventListener("pointerup", up); };
  }, [onChange]);
  const clear = () => { const c = ref.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); used.current = false; onChange(null); };
  return (
    <div>
      <canvas ref={ref} width={600} height={160} style={{ width: "100%", height: 120, border: "1.5px dashed #C9D8E8", borderRadius: 8, background: "#fff", touchAction: "none" }} />
      <button type="button" onClick={clear} style={{ background: "none", border: "none", color: "var(--sub)", fontSize: 12, cursor: "pointer", padding: 0 }}>Clear drawing</button>
    </div>
  );
}
